export const normalizeString = (denormal: string, ignoreCase = false) => {
    const scoreTextPattern = /[^a-zA-Z0-9\s]/g;
    const result = denormal.replace(scoreTextPattern, '');

    return ignoreCase ? result.toLocaleLowerCase() : result;
};
